module.exports = __webpack_public_path__ + "media/images/flags/sd-73b28dc2d0bc878af9c8f9adf77ae770.svg";